/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AppControllerResponse } from '../../src/model';
// @ts-ignore
import type { UuidToDateResponse } from '../../src/model';
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
export const HealthCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 해당 날짜의 시작 uuid와 끝 uuid 조회
         * @param {string} todayDate 시작 날짜
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appController: async (todayDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todayDate' is not null or undefined
            assertParamExists('appController', 'todayDate', todayDate)
            const localVarPath = `/uuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (todayDate !== undefined) {
                localVarQueryParameter['todayDate'] = (todayDate as any instanceof Date) ?
                    (todayDate as any).toISOString() :
                    todayDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerCheckServerHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHttpUrlTest: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('appControllerHttpUrlTest', 'key', key)
            const localVarPath = `/http-url-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uuid로 날짜 조회 API
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uuidToDate: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('uuidToDate', 'uuid', uuid)
            const localVarPath = `/uuid-to-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckApi - functional programming interface
 * @export
 */
export const HealthCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 해당 날짜의 시작 uuid와 끝 uuid 조회
         * @param {string} todayDate 시작 날짜
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appController(todayDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppControllerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appController(todayDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckApi.appController']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerCheckServerHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerCheckServerHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckApi.appControllerCheckServerHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerHttpUrlTest(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerHttpUrlTest(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckApi.appControllerHttpUrlTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary uuid로 날짜 조회 API
         * @param {string} uuid uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uuidToDate(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UuidToDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uuidToDate(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckApi.uuidToDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthCheckApi - factory interface
 * @export
 */
export const HealthCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckApiFp(configuration)
    return {
        /**
         * 
         * @summary 해당 날짜의 시작 uuid와 끝 uuid 조회
         * @param {HealthCheckApiAppControllerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appController(requestParameters: HealthCheckApiAppControllerRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppControllerResponse> {
            return localVarFp.appController(requestParameters.todayDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerCheckServerHealth(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appControllerCheckServerHealth(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HealthCheckApiAppControllerHttpUrlTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHttpUrlTest(requestParameters: HealthCheckApiAppControllerHttpUrlTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appControllerHttpUrlTest(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uuid로 날짜 조회 API
         * @param {HealthCheckApiUuidToDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uuidToDate(requestParameters: HealthCheckApiUuidToDateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UuidToDateResponse> {
            return localVarFp.uuidToDate(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appController operation in HealthCheckApi.
 * @export
 * @interface HealthCheckApiAppControllerRequest
 */
export interface HealthCheckApiAppControllerRequest {
    /**
     * 시작 날짜
     * @type {string}
     * @memberof HealthCheckApiAppController
     */
    readonly todayDate: string
}

/**
 * Request parameters for appControllerHttpUrlTest operation in HealthCheckApi.
 * @export
 * @interface HealthCheckApiAppControllerHttpUrlTestRequest
 */
export interface HealthCheckApiAppControllerHttpUrlTestRequest {
    /**
     * 
     * @type {string}
     * @memberof HealthCheckApiAppControllerHttpUrlTest
     */
    readonly key: string
}

/**
 * Request parameters for uuidToDate operation in HealthCheckApi.
 * @export
 * @interface HealthCheckApiUuidToDateRequest
 */
export interface HealthCheckApiUuidToDateRequest {
    /**
     * uuid
     * @type {string}
     * @memberof HealthCheckApiUuidToDate
     */
    readonly uuid: string
}

/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
export class HealthCheckApi extends BaseAPI {
    /**
     * 
     * @summary 해당 날짜의 시작 uuid와 끝 uuid 조회
     * @param {HealthCheckApiAppControllerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public appController(requestParameters: HealthCheckApiAppControllerRequest, options?: RawAxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).appController(requestParameters.todayDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public appControllerCheckServerHealth(options?: RawAxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).appControllerCheckServerHealth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HealthCheckApiAppControllerHttpUrlTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public appControllerHttpUrlTest(requestParameters: HealthCheckApiAppControllerHttpUrlTestRequest, options?: RawAxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).appControllerHttpUrlTest(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uuid로 날짜 조회 API
     * @param {HealthCheckApiUuidToDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public uuidToDate(requestParameters: HealthCheckApiUuidToDateRequest, options?: RawAxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).uuidToDate(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }
}

